import * as hpServicesApi from "../../api/healthPlanServicesApi";
import * as types from "../../constants/actionTypes";
import { call, put, select } from "redux-saga/effects";
import { logAPI } from "../../api/andyliticsApi";

export function* getInvoices(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    const memid = domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.subscriptionHccId;

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.InvoiceApi.getInvoicesList, domainData.t, memid, params.startDate, params.endDate);
            logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.GetInvoices.Get", start, null);
            yield put({ type: types.HP_GET_INVOICES_LIST_SUCCESS, invoices: response, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.GetInvoices.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_INVOICES_LIST_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.GetInvoices.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getInvoiceDetails(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    //const sessionData = yield select((state) => state.session);

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.InvoiceApi.getInvoiceDetails, domainData.t, params.invoiceId);
            logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.GetInvoicesDetails.Get", start, null);
            yield put({ type: types.HP_GET_INVOICE_DETAIL_SUCCESS, invoiceDetails: response, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.GetInvoicesDetails.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_INVOICE_DETAIL_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.GetInvoicesDetails.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getInvoiceAdjustments(params) {

    const start = new Date();
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    const domainData = yield select((state) => state.domain);

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.InvoiceApi.getInvoiceAdjustments, domainData.t, params.invoiceId);
            logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.GetInvoicesAdjustments.Get", start, null);
            yield put({ type: types.HP_GET_INVOICE_ADJUSTMENTS_SUCCESS, invoiceAdjustments: response, isFetching: false });
        }
        catch (response) {
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.WebTPA.Invoices.GetInvoicesAdjustments.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_INVOICE_DETAIL_FAILURE, error: response });
                logAPI("MBHWeb.Saga.WebTPA.Invoices.GetInvoicesAdjustments.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getDentalInvoiceDetails(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    //const sessionData = yield select((state) => state.session);

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.InvoiceApi.getDentalInvoiceDetails, domainData.t, params.memberId);
            logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.GetDentalInvoiceDetails.Get", start, null);
            yield put({ type: types.HP_GET_DENTAL_INVOICE_DETAIL_SUCCESS, dentalInvoiceDetails: response, isFetching: false });
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.GetDentalInvoiceDetails.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else if (response.status === 417) {
                yield put({ type: types.HP_GET_DENTAL_INVOICE_DETAIL_FAILURE, error: "Member Has No Dental Contract" });
                logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.DetDentalInvoiceDetails.Failure", start, null, response);            }
            else {
                yield put({ type: types.HP_GET_DENTAL_INVOICE_DETAIL_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Invoices.DetDentalInvoiceDetails.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}